import nestApi from '../nestApi';

const feedbackGroupApi = nestApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeedbackGroup: builder.query({
      query: (params) => ({
        url: `feedback-group/feedback-question/${params.groupId}/${params.userId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup'],
    }),
    getAllFeedbackGroup: builder.query({
      query: (params) => ({
        url: `feedback-group/${params.courseId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    getFeedbackGroupByUserId: builder.query({
      query: (params) => ({
        url: `feedback-group/chapters/${params.courseId}/${params.userId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    addFeedbackGroup: builder.mutation({
      query: (params) => ({
        url: `feedback-group/${params.legend}/${params.surveyId}`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup'],
    }),
    addFeedbackGroupBySurveyId: builder.mutation({
      query: (params) => ({
        url: `feedback-group/${params.surveyId}`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    updateFeedbackGroup: builder.mutation({
      query: (params) => ({
        url: `feedback-group/${params.id}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup'],
    }),
    updateFeedbackGroupTitle: builder.mutation({
      query: (params) => ({
        url: `feedback-group/update-title/${params.id}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup'],
    }),

    addSurveyAnswer: builder.mutation({
      query: (params) => ({
        url: `survey-answer`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['SurveyAnswer'],
    }),
    getSurveyAnswer: builder.query({
      query: (params) => ({
        url: `survey-answer/${params.userId}`,
        method: 'GET',
        params: { chapterId: params.chapterId },
      }),
      providesTags: ['SurveyAnswer'],
    }),
    updateSurveyAnswer: builder.mutation({
      query: (params) => ({
        url: `survey-answer/${params.userId}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['SurveyAnswer'],
    }),
    getSurvey: builder.query({
      query: (params) => ({
        url: `surveys/${params.surveyId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['SurveyAnswer'],
    }),
    getFeedbackGroupsBySurveyId: builder.query({
      query: (params) => ({
        url: `feedback-group/feedback-groups/${params.surveyId}`,
        method: 'GET',
        // params,
      }),
      providesTags: ['FeedbackGroup'],
    }),
    createSurvey: builder.mutation({
      query: (params) => ({
        url: `surveys/create`,
        method: 'POST',
        body: params,
      }),
    }),
    updateSurvey: builder.mutation({
      query: (params) => ({
        url: `surveys/${params.id}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    getAllSurveys: builder.query({
      query: (params) => ({
        url: `surveys/user/${params.userId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    getSurveyByCourseId: builder.query({
      query: (params) => ({
        url: `surveys/getSurveyByCourseId/${params.courseId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    createFeedbackQuestion: builder.mutation({
      query: (params) => ({
        url: `feedback-question/create-question/${params.feedbackGroupId}`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup'],
    }),
    createFeedbackGroup: builder.mutation({
      query: (params) => ({
        url: `feedback-group/create-group/legend/${params.surveyId}`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup'],
    }),
    deleteFeedbackGroup: builder.mutation({
      query: (params) => ({
        url: `feedback-group/${params.id}`,
        method: 'DELETE',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup'],
    }),
    deleteSurvey: builder.mutation({
      query: (params) => ({
        url: `surveys/${params.id}`,
        method: 'DELETE',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    getSurveyByChapterId: builder.query({
      query: (params) => ({
        url: `surveys/getSurveyByChapterId/${params.chapterId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    getSurveyByUserId: builder.query({
      query: (params) => ({
        url: `surveys/getSurveyByUser/${params.userId}/${params.chapterId}`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    unAttachSurvey: builder.mutation({
      query: (params) => ({
        url: `surveys/detachSurvey`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    getSurveyNumericData: builder.query({
      query: (params) => ({
        url: `survey-answer/numeric`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
    getMemberListData: builder.query({
      query: (params) => ({
        url: `survey-answer/members`,
        method: 'GET',
        params,
      }),
      providesTags: ['FeedbackGroup', 'SurveyAnswer'],
    }),
  }),
});

export const {
  useGetFeedbackGroupQuery,
  useAddFeedbackGroupMutation,
  useAddSurveyAnswerMutation,
  useUpdateFeedbackGroupMutation,
  useUpdateSurveyAnswerMutation,
  useGetSurveyAnswerQuery,
  useGetAllFeedbackGroupQuery,
  useGetFeedbackGroupByUserIdQuery,
  useCreateSurveyMutation,
  useUpdateSurveyMutation,
  useGetSurveyQuery,
  useAddFeedbackGroupBySurveyIdMutation,
  useGetFeedbackGroupsBySurveyIdQuery,
  useGetAllSurveysQuery,
  useCreateFeedbackQuestionMutation,
  useUpdateFeedbackGroupTitleMutation,
  useCreateFeedbackGroupMutation,
  useDeleteFeedbackGroupMutation,
  useGetSurveyByChapterIdQuery,
  useDeleteSurveyMutation,
  useGetSurveyByCourseIdQuery,
  useUnAttachSurveyMutation,
  useGetSurveyByUserIdQuery,
  useGetSurveyNumericDataQuery,
  useGetMemberListDataQuery,
} = feedbackGroupApi;
export default feedbackGroupApi;
